export default "__VITE_ASSET__BjPK6TEv__"